import AppShowcase from './components/AppShowcase/AppShowcase';
import Header from './components/Header/Header';
import './Home.scss';

function Home() {
  return (
    <div className="Home">
      <Header />
      {/* <AppShowcase /> */}
    </div>
  );
}

export default Home;
